import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/";
const StyledSVG = styled("svg", {
    shouldForwardProp: (prop) => prop !== "color",
})(({ theme, color }) => ({
    fill: theme.palette[color].main,
}));
// tests covered by Icon.spec.tsx
const StyledCustomIcon = ({ children, color, fontSize, testId, }) => {
    // svg doesn't center or scale correctly if we add units
    const iconSizes = {
        extraSmall: "12",
        small: "18",
        medium: "20",
        large: "24",
        extraLarge: "48",
    };
    const iconScale = iconSizes[fontSize];
    const viewBox = `0 0 ${iconScale} ${iconScale}`;
    return (_jsx(StyledSVG, Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: viewBox, width: iconScale, height: iconScale, "data-testid": testId, color: color }, { children: children })));
};
export default StyledCustomIcon;
